export interface LocaleText {
  pt: string;
  es: string;
  en: string;
}

export const ADMIN = {
  pt: "Admin",
  es: "Admin",
  en: "Admin",
};

export const APIS = {
  pt: "APIs",
  es: "APIs",
  en: "APIs",
};

export const OCPI_API_PERMISSIONS_TITLE = {
  pt: "Gerar Token de Autenticação",
  es: "Generar Token de Autenticación",
  en: "Generate Authentication Token"
}

export const OCPI_API_DOCUMENTATION_TITLE = {
  pt: "Documentação das APIs",
  es: "Documentación de las APIs",
  en: "API Documentation"
}
export const OCPI_API_DOCUMENTATION_DESCRIPTION = {
  pt: "Todas as APIs seguem o protocolo OCPI 2.2.1 e requerem autenticação via token no header.",
  es: "Todas las API siguen el protocolo OCPI 2.2.1 y requieren autenticación mediante un token en el encabezado.",
  en: "All APIs follow the OCPI 2.2.1 protocol and require authentication via token in the header."
}
export const GENERATE_NEW_TOKEN = {
  pt: "Gerar Novo Token",
  es: "Generar Nuevo Token",
  en: "Generate New Token"
}

export const ERROR_GENERATE_TOKEN = {
  pt: "Erro ao gerar novo Token",
  es: "error en generar nuevo Token",
  en: "Error in generate New Token"
}
export const ERROR_FETCHING_COMPANIES = {
  pt: "Erro ao buscar empresas",
  es: "error al buscar empresas",
  en: "Error fetching companies"
}

export const ERROR_CHECK_PARTY_TOKEN: LocaleText = {
  pt: "Erro ao verificar token existente.",
  es: "Error al verificar el token existente.",
  en: "Error checking existing token.",
};

export const SUCCESS_GENERATE_TOKEN = {
  pt: "Token gerado com sucesso!",
  es: "Token generado con successo",
  en: "Token generated successfully"
}

export const SUCCESS_GENERATE_TOKEN_MESSAGE = {
  pt: "IMPORTANTE: Este token será exibido apenas uma vez. Copie e armazene-o em um local seguro imediatamente. Você não poderá visualizá-lo novamente após fechar esta mensagem.",
  es: "IMPORTANTE: Este token solo se mostrará una vez. Cópielo y guárdelo en un lugar seguro inmediatamente. No podrá volver a verlo después de cerrar este mensaje.",
  en: "IMPORTANT: This token will only be displayed once. Copy and store it in a safe place immediately. You will not be able to view it again after closing this message."
}

export const SET_PARTY_ID_TITLE: LocaleText = {
  pt: "Defina um Party ID para esta empresa",
  es: "Definir Party ID de la empresa",
  en: "Set company Party ID",
};

export const SET_PARTY_ID_DESCRIPTION: LocaleText = {
  pt: "Identificamos que esta empresa não possui um Party ID (Identificador OCPI), necessário para gerar o token de acesso à API.",
  es: "Esta empresa aún no tiene un Party ID. Ingrese un identificador de 3 caracteres alfanuméricos (debe ser único) para poder generar el token.",
  en: "This company doesn't have a Party ID yet. Enter a 3 alphanumeric-character identifier (must be unique) to be able to generate the token.",
};

export const SET_PARTY_ID_INSTRUCTIONS: LocaleText = {
  pt: "Para gerar o token, insira um identificador único de 3 caracteres alfanuméricos. Ex.: (TUP) e depois toque em \"Gerar Novo Token\"",
  es: "Para generar el token, ingrese un identificador único de 3 caracteres alfanuméricos. Ej.: (TUP) y luego toque \"Generar Nuevo Token\"",
  en: "To generate the token, enter a unique 3-character alphanumeric identifier. Example: (TUP), then click \"Generate New Token\"",
};

export const REGENERATE_TOKEN_CONFIRM_TITLE: LocaleText = {
  pt: "Tem certeza que deseja gerar um novo token?",
  es: "¿Está seguro de que desea generar un nuevo token?",
  en: "Are you sure you want to generate a new token?",
};

export const REGENERATE_TOKEN_CONFIRM_DESCRIPTION: LocaleText = {
  pt: "Caso prossiga, o token anterior será invalidado.",
  es: "Si continúa, el token anterior será invalidado.",
  en: "If you continue, the previous token will be invalidated.",
};

export const PARTY_ID_INVALID_FORMAT: LocaleText = {
  pt: "O Party ID deve ter exatamente 3 caracteres alfanuméricos (A-Z, 0-9).",
  es: "El Party ID debe tener exactamente 3 caracteres alfanuméricos (A-Z, 0-9).",
  en: "The Party ID must be exactly 3 alphanumeric characters (A-Z, 0-9).",
};

export const ERROR_SAVE_PARTY_ID: LocaleText = {
  pt: "Erro ao salvar o Party ID.",
  es: "Error al guardar el Party ID.",
  en: "Error saving the Party ID.",
};

export const SAVE: LocaleText = {
  pt: "Salvar",
  es: "Guardar",
  en: "Save",
};

export const CANCEL: LocaleText = {
  pt: "Cancelar",
  es: "Cancelar",
  en: "Cancel",
};

export const LOCATIONS_ENDPOINT_DESCRIPTION = {
  pt: "Recupera a lista de localizações (estações de carregamento) disponíveis, incluindo informações sobre EVSEs, conectores, endereços e coordenadas geográficas."
}

// ─── API docs card ────────────────────────────────────────────────────────────

export const API_DOCS_TITLE: LocaleText = {
  pt: "Documentação da API OCPI",
  es: "Documentación de la API OCPI",
  en: "OCPI API Documentation",
};

export const AVAILABLE_ENDPOINTS: LocaleText = {
  pt: "Endpoints disponíveis",
  es: "Endpoints disponibles",
  en: "Available endpoints",
};

// ─── EndpointCard UI labels ───────────────────────────────────────────────────

export const AUTH_LABEL: LocaleText = {
  pt: "Autenticação",
  es: "Autenticación",
  en: "Authentication",
};

export const PARAMS_LABEL: LocaleText = {
  pt: "Parâmetros",
  es: "Parámetros",
  en: "Parameters",
};

export const PARAM_COL_NAME: LocaleText = {
  pt: "Nome",
  es: "Nombre",
  en: "Name",
};

export const PARAM_COL_REQUIRED: LocaleText = {
  pt: "Obrigatório",
  es: "Obligatorio",
  en: "Required",
};

export const PARAM_COL_DESCRIPTION: LocaleText = {
  pt: "Descrição",
  es: "Descripción",
  en: "Description",
};

export const REQUIRED_YES: LocaleText = {
  pt: "Sim",
  es: "Sí",
  en: "Yes",
};

export const REQUIRED_NO: LocaleText = {
  pt: "Não",
  es: "No",
  en: "No",
};

export const RESPONSE_LABEL: LocaleText = {
  pt: "Resposta",
  es: "Respuesta",
  en: "Response",
};

export const SHOW_CURL: LocaleText = {
  pt: "▼ Mostrar exemplo de requisição",
  es: "▼ Mostrar ejemplo de solicitud",
  en: "▼ Show request example",
};

export const HIDE_CURL: LocaleText = {
  pt: "▲ Ocultar exemplo de requisição",
  es: "▲ Ocultar ejemplo de solicitud",
  en: "▲ Hide request example",
};

// ─── GET Locations endpoint ───────────────────────────────────────────────────

export const GET_LOCATIONS_NAME: LocaleText = {
  pt: "Locations (OCPI)",
  es: "Locations (OCPI)",
  en: "Locations (OCPI)",
};

export const GET_LOCATIONS_DESCRIPTION: LocaleText = {
  pt: "Recupera as localizações (estações) disponíveis, com EVSEs, conectores, endereço e coordenadas. {version} pode ser 2.2.1 ou 2.2; em 2.2 alguns tipos de conector/potência e capacidades não são retornados.",
  es: "Recupera las ubicaciones (estaciones) disponibles, con EVSEs, conectores, dirección y coordenadas. {version} puede ser 2.2.1 o 2.2; en 2.2 algunos tipos de conector/potencia y capacidades no se devuelven.",
  en: "Retrieves available locations (stations) with EVSEs, connectors, address and coordinates. {version} can be 2.2.1 or 2.2; under 2.2 some connector/power types and capabilities are not returned.",
};

export const GET_AUTH: LocaleText = {
  pt: "Header Authorization: Token <token>",
  es: "Header Authorization: Token <token>",
  en: "Header Authorization: Token <token>",
};

export const GET_LOCATIONS_RESPONSE: LocaleText = {
  pt: "Array de objetos Location no envelope OCPI",
  es: "Array de objetos Location en el envelope OCPI",
  en: "Array of Location objects in the OCPI envelope",
};

export const PARAM_LIMIT_DESC: LocaleText = {
  pt: "Limite de resultados",
  es: "Límite de resultados",
  en: "Result limit",
};

export const PARAM_OFFSET_DESC: LocaleText = {
  pt: "Deslocamento para paginação",
  es: "Desplazamiento para paginación",
  en: "Pagination offset",
};

export const PARAM_DATE_FROM_DESC: LocaleText = {
  pt: "Filtrar registros a partir desta data (ISO 8601)",
  es: "Filtrar registros a partir de esta fecha (ISO 8601)",
  en: "Filter records from this date onwards (ISO 8601)",
};

export const PARAM_DATE_TO_DESC: LocaleText = {
  pt: "Filtrar registros até esta data (ISO 8601)",
  es: "Filtrar registros hasta esta fecha (ISO 8601)",
  en: "Filter records up to this date (ISO 8601)",
};

export const GET_SESSIONS_NAME: LocaleText = {
  pt: "Sessions (OCPI)",
  es: "Sessions (OCPI)",
  en: "Sessions (OCPI)",
};

export const GET_SESSIONS_DESCRIPTION: LocaleText = {
  pt: "Lista as sessões de carregamento, com energia (kWh), custos, períodos de carga, status e referências de localização/EVSE/conector.",
  es: "Lista las sesiones de carga, con energía (kWh), costos, periodos de carga, estado y referencias de ubicación/EVSE/conector.",
  en: "Lists charging sessions with energy (kWh), costs, charging periods, status and location/EVSE/connector references."
};

export const GET_SESSIONS_RESPONSE: LocaleText = {
  pt: "Array de objetos Session no envelope OCPI",
  es: "Matriz de objetos Session en el sobre OCPI.",
  en: "Array of Session objects in OCPI envelope"
};

export const GET_SESSION_USER_NAME: LocaleText = {
  pt: "Session User Data (Extra)",
  es: "Session User Data (Extra)",
  en: "Session User Data (Extra)",
};

export const GET_SESSION_USER_DESCRIPTION: LocaleText = {
  pt: "Endpoint Tupi (fora do padrão OCPI) que retorna os dados do usuário de uma sessão: dados pessoais, endereço de cobrança e veículos. A busca usa o party_id da empresa requerente.",
  es: "Endpoint de Tupi (fuera del estándar OCPI) que devuelve los datos del usuario de una sesión: datos personales, dirección de facturación y vehículos. La búsqueda usa el party_id de la empresa solicitante.",
  en: "Tupi endpoint (outside the OCPI standard) returning the user data of a session: personal data, billing address and vehicles. Lookup uses the requesting company's party_id."
};

export const GET_SESSION_USER_RESPONSE: LocaleText = {
  pt: "Objeto com user_data contendo nome, documento, email, telefone e endereço",
  es: "Objeto con datos de usuario que contienen nombre, número de documento, correo electrónico, teléfono y dirección.",
  en: "Object with user_data containing name, document number, email, phone, and address."
};

export const PARAM_COUNTRY_CODE_DESC: LocaleText = {
  pt: "Código do país (ex: BR)",
  es: "Código del pays (ex: BR)",
  en: "Country code (ex: BR)"
};

export const PARAM_PARTY_ID_DESC: LocaleText = {
  pt: "Party ID (ex: TUP)",
  es: "Party ID (ex: TUP)",
  en: "Party ID (ex: TUP)"
};

export const PARAM_SESSION_ID_DESC: LocaleText = {
  pt: "ID de sessão",
  es: "ID de sessión",
  en: "Session ID"
};

export const COMPLETE_DOCS_AT: LocaleText = {
  pt: "Nossa API é baseada na OCPI e a documentação completa OCPI 2.2.1 pode ser encontrada",
  es: "Nuestra API se basa en OCPI y la documentación completa OCPI 2.2.1 se puede encontrar",
  en: "Our API is based on OCPI and the complete OCPI 2.2.1 documentation can be found"
}

export const DOCS_LINK_HERE: LocaleText = {
  pt: "aqui",
  es: "aquí",
  en: "here",
}

export const COMPANY: LocaleText = {
  pt: "Empresa",
  es: "Empresa",
  en: "Company"
}

export const COMPANY_DESCRIPTION: LocaleText = {
  pt: "O token será gerado para a empresa selecionada e suas empresas filhas (se houver) ",
  es: "El token se generará para la empresa seleccionada y sus empresas subsidiarias (si las hubiera).",
  en: "The token will be generated for the selected company and their child companies (if exists)"
}

export const ATTENTION: LocaleText = {
  pt: "Atenção: Configuração necessária",
  es: "Atención: Se requiere configuración.",
  en: "Attention: Configuration required"
}

export const ATTENTION_DESCRIPTION: LocaleText = {
  pt: "Antes de gerar o token, certifique-se de preencher o campo OCPI party_id no menu Empresas. Este identificador é obrigatório para que a API funcione corretamente.",
  es: "Antes de generar el token, asegúrese de completar el campo party_id de OCPI en el menú Empresas. Este identificador es necesario para que la API funcione correctamente.",
  en: "Before generating the token, be sure to fill in the OCPI party_id field in the Companies menu. This identifier is required for the API to function correctly."
}

export const CLOSE_TOKEN: LocaleText = {
  pt: "Entendi, fechar",
  es: "Comprendo, cerrar",
  en: "Understood, close"
}

export const COPY_TOKEN: LocaleText = {
  pt: "Copiar Token",
  es: "Copiar Token",
  en: "Copy Token"
}

export const TOKEN_COPIED: LocaleText = {
  pt: "Token copiado!",
  es: "¡Token copiado!",
  en: "Token copied!",
};

export const REVOKE_TOKEN: LocaleText = {
  pt: "Revogar Token",
  es: "Revogar Token",
  en: "Revoke Token"
}

export const TOKEN_REVOKED: LocaleText = {
  pt: "Token Revogado",
  es: "Token Revogado",
  en: "Token Revoked"
}

// ─── Endpoint card section labels ───────────────────────────────────────────────

export const ENDPOINT_LABEL: LocaleText = {
  pt: "Endpoint",
  es: "Endpoint",
  en: "Endpoint",
};

export const PROTOCOL_LABEL: LocaleText = {
  pt: "Protocolo",
  es: "Protocolo",
  en: "Protocol",
};

export const CONTENT_TYPE_LABEL: LocaleText = {
  pt: "Content type",
  es: "Content type",
  en: "Content type",
};

export const PARAM_COL_IN: LocaleText = {
  pt: "Local",
  es: "Ubicación",
  en: "In",
};

export const PARAM_COL_TYPE: LocaleText = {
  pt: "Tipo",
  es: "Tipo",
  en: "Type",
};

export const RESPONSE_FIELDS_LABEL: LocaleText = {
  pt: "Campos da resposta",
  es: "Campos de la respuesta",
  en: "Response fields",
};

export const FIELD_COL_FIELD: LocaleText = {
  pt: "Campo",
  es: "Campo",
  en: "Field",
};

export const FIELD_COL_VALUES: LocaleText = {
  pt: "Valores possíveis",
  es: "Valores posibles",
  en: "Possible values",
};

export const RESPONSE_EXAMPLE_LABEL: LocaleText = {
  pt: "Exemplo de resposta",
  es: "Ejemplo de respuesta",
  en: "Response example",
};

export const PAGINATION_HEADERS_LABEL: LocaleText = {
  pt: "Headers de paginação",
  es: "Headers de paginación",
  en: "Pagination headers",
};

export const HEADER_COL_NAME: LocaleText = {
  pt: "Header",
  es: "Header",
  en: "Header",
};

export const ACCESS_CONTROL_LABEL: LocaleText = {
  pt: "Controle de acesso",
  es: "Control de acceso",
  en: "Access control",
};

export const NOTES_LABEL: LocaleText = {
  pt: "Observações",
  es: "Observaciones",
  en: "Notes",
};

export const ERRORS_LABEL: LocaleText = {
  pt: "Respostas de erro",
  es: "Respuestas de error",
  en: "Error responses",
};

export const ERROR_COL_CODE: LocaleText = {
  pt: "Código",
  es: "Código",
  en: "Code",
};

export const REQUEST_EXAMPLE_LABEL: LocaleText = {
  pt: "Exemplo de requisição",
  es: "Ejemplo de solicitud",
  en: "Request example",
};

export const EXPAND_ALL: LocaleText = {
  pt: "Expandir todos",
  es: "Expandir todos",
  en: "Expand all",
};

export const COLLAPSE_ALL: LocaleText = {
  pt: "Recolher todos",
  es: "Contraer todos",
  en: "Collapse all",
};

// ─── API doc content: authentication ────────────────────────────────────────────

// Prose only — the literal "Authorization: Token <token>" header is rendered as
// a code chip in the UI, so all endpoints share the same explanatory text.
export const DOC_AUTH_TOKEN: LocaleText = {
  pt: "Envie no header HTTP, com o token fornecido como está.",
  es: "Envíelo en el header HTTP, con el token proporcionado tal cual.",
  en: "Send it in the HTTP header, with the provided token as-is.",
};

// The fixed HTTP header format shown as a code chip (not translated).
export const DOC_AUTH_HEADER_LITERAL = "Authorization: Token <token>";

// ─── API doc content: shared parameters ─────────────────────────────────────────

export const DOC_PARAM_AUTH_DESC: LocaleText = {
  pt: "Token <token> fornecido pela Tupi.",
  es: "Token <token> proporcionado por Tupi.",
  en: "Token <token> provided by Tupi.",
};

export const DOC_PARAM_VERSION_DESC: LocaleText = {
  pt: "Versão do protocolo OCPI no path. Use 2.2.1 (recomendada); 2.2 está deprecada.",
  es: "Versión del protocolo OCPI en el path. Use 2.2.1 (recomendada); 2.2 está obsoleta.",
  en: "OCPI protocol version in the path. Use 2.2.1 (recommended); 2.2 is deprecated.",
};

export const DOC_PARAM_LIMIT_DESC: LocaleText = {
  pt: "Quantidade máxima de itens por página. O servidor pode limitar o teto.",
  es: "Cantidad máxima de ítems por página. El servidor puede limitar el máximo.",
  en: "Maximum number of items per page. The server may cap the maximum.",
};

export const DOC_PARAM_OFFSET_DESC: LocaleText = {
  pt: "Deslocamento para paginação. Começa em 0.",
  es: "Desplazamiento para paginación. Empieza en 0.",
  en: "Pagination offset. Starts at 0.",
};

export const DOC_PARAM_DATE_FROM_DESC: LocaleText = {
  pt: "Retorna itens atualizados a partir deste instante (inclusive).",
  es: "Devuelve ítems actualizados desde este instante (inclusive).",
  en: "Returns items updated at or after this moment.",
};

export const DOC_PARAM_DATE_TO_DESC: LocaleText = {
  pt: "Retorna itens atualizados até este instante (inclusive).",
  es: "Devuelve ítems actualizados hasta este instante (inclusive).",
  en: "Returns items updated at or before this moment.",
};

export const DOC_PARAM_UD_COUNTRY_DESC: LocaleText = {
  pt: "Código de país OCPI de 2 letras do CPO (ex.: BR).",
  es: "Código de país OCPI de 2 letras del CPO (ej.: BR).",
  en: "Two-letter OCPI country code of the CPO (e.g. BR).",
};

export const DOC_PARAM_UD_PARTY_DESC: LocaleText = {
  pt: "Party ID de 3 letras — o mesmo party para o qual o token foi gerado (o ocpiPartyId da empresa).",
  es: "Party ID de 3 letras — el mismo party para el que se generó el token (el ocpiPartyId de la empresa).",
  en: "Three-letter party ID — the same party the token was generated for (the company's ocpiPartyId).",
};

export const DOC_PARAM_UD_SESSION_DESC: LocaleText = {
  pt: "Identificador da sessão.",
  es: "Identificador de la sesión.",
  en: "Session identifier.",
};

// ─── API doc content: OCPI envelope (shared) ────────────────────────────────────

export const DOC_ENV_STATUS_CODE: LocaleText = {
  pt: "Código de status OCPI (1000 = sucesso).",
  es: "Código de estado OCPI (1000 = éxito).",
  en: "OCPI status code (1000 = success).",
};

export const DOC_ENV_STATUS_MESSAGE: LocaleText = {
  pt: "Mensagem legível associada ao status.",
  es: "Mensaje legible asociado al estado.",
  en: "Human-readable message for the status.",
};

export const DOC_ENV_TIMESTAMP: LocaleText = {
  pt: "Momento em que a resposta foi gerada.",
  es: "Momento en que se generó la respuesta.",
  en: "Moment the response was generated.",
};

// ─── API doc content: pagination headers (shared) ───────────────────────────────

export const DOC_HDR_LINK: LocaleText = {
  pt: 'URL da próxima página no formato <{url}>; rel="next" quando há mais páginas.',
  es: 'URL de la página siguiente en formato <{url}>; rel="next" cuando hay más páginas.',
  en: 'Next-page URL in the form <{url}>; rel="next" when more pages exist.',
};

export const DOC_HDR_TOTAL_COUNT: LocaleText = {
  pt: "Total de itens em todas as páginas.",
  es: "Total de ítems en todas las páginas.",
  en: "Total number of items across all pages.",
};

export const DOC_HDR_LIMIT: LocaleText = {
  pt: "Tamanho de página usado nesta resposta.",
  es: "Tamaño de página usado en esta respuesta.",
  en: "Page size used for this response.",
};

// ─── API doc content: error responses ───────────────────────────────────────────

export const DOC_ERR_400: LocaleText = {
  pt: "Parâmetros de query inválidos (ex.: limit não numérico, data malformada).",
  es: "Parámetros de query inválidos (ej.: limit no numérico, fecha malformada).",
  en: "Invalid query parameters (e.g. non-numeric limit, malformed date).",
};

export const DOC_ERR_401: LocaleText = {
  pt: "Header Authorization ausente/inválido ou party não autorizada.",
  es: "Header Authorization ausente/inválido o party no autorizada.",
  en: "Missing/invalid Authorization header, or unauthorized party.",
};

export const DOC_ERR_422: LocaleText = {
  pt: "Erros de validação nos parâmetros (path/query) ou no payload.",
  es: "Errores de validación en los parámetros (path/query) o en el payload.",
  en: "Validation errors in the parameters (path/query) or payload.",
};

export const DOC_ERR_4XX: LocaleText = {
  pt: "Outros erros de cliente não listados acima.",
  es: "Otros errores de cliente no listados arriba.",
  en: "Other client errors not listed above.",
};

export const DOC_ERR_5XX: LocaleText = {
  pt: "Erro interno ao processar a requisição.",
  es: "Error interno al procesar la solicitud.",
  en: "Internal error while serving the request.",
};

export const DOC_ERR_UD_401: LocaleText = {
  pt: "Header ausente/inválido, token malformado ou sem permissão para o party_id.",
  es: "Header ausente/inválido, token malformado o sin permiso para el party_id.",
  en: "Missing/invalid header, malformed token, or no permission for the party_id.",
};

export const DOC_ERR_UD_404: LocaleText = {
  pt: "Sessão ou usuário não encontrado.",
  es: "Sesión o usuario no encontrado.",
  en: "Session or user not found.",
};

// ─── API doc content: access control / notes ────────────────────────────────────

export const DOC_AC_LOCATIONS: LocaleText = {
  pt: "Você só terá acesso às estações permitidas pelo token de autorização fornecido.",
  es: "Solo tendrá acceso a las estaciones permitidas por el token de autorización proporcionado.",
  en: "You only have access to the stations allowed by the provided authorization token.",
};

export const DOC_AC_SESSIONS: LocaleText = {
  pt: "Você só terá acesso às sessões das parties permitidas pelo token fornecido.",
  es: "Solo tendrá acceso a las sesiones de las parties permitidas por el token proporcionado.",
  en: "You only have access to sessions of the parties allowed by the provided token.",
};

export const DOC_NOTE_SESSIONS: LocaleText = {
  pt: "Por enquanto, location_id e evse_uid são iguais ao stationID.",
  es: "Por ahora, location_id y evse_uid son iguales al stationID.",
  en: "For now, location_id and evse_uid are the same as the stationID.",
};

// ─── API doc content: Locations response fields ─────────────────────────────────

export const DOC_LOC_DATA: LocaleText = {
  pt: "Array de objetos Location OCPI.",
  es: "Array de objetos Location OCPI.",
  en: "Array of OCPI Location objects.",
};
export const DOC_LOC_ID: LocaleText = {
  pt: "Identificador único da localização.",
  es: "Identificador único de la ubicación.",
  en: "Unique location identifier.",
};
export const DOC_LOC_COUNTRY_CODE: LocaleText = {
  pt: "Código do país (ISO-3166 alpha-2), ex.: BR.",
  es: "Código del país (ISO-3166 alpha-2), ej.: BR.",
  en: "Country code (ISO-3166 alpha-2), e.g. BR.",
};
export const DOC_LOC_PARTY_ID: LocaleText = {
  pt: "Party ID OCPI do CPO (3 letras).",
  es: "Party ID OCPI del CPO (3 letras).",
  en: "OCPI party ID of the CPO (3 letters).",
};
export const DOC_LOC_PUBLISH: LocaleText = {
  pt: "Se a localização é pública/publicável.",
  es: "Si la ubicación es pública/publicable.",
  en: "Whether the location is public/publishable.",
};
export const DOC_LOC_NAME: LocaleText = {
  pt: "Nome da localização.",
  es: "Nombre de la ubicación.",
  en: "Location name.",
};
export const DOC_LOC_ADDRESS: LocaleText = {
  pt: "Endereço (logradouro).",
  es: "Dirección (calle).",
  en: "Street address.",
};
export const DOC_LOC_CITY: LocaleText = {
  pt: "Cidade.",
  es: "Ciudad.",
  en: "City.",
};
export const DOC_LOC_COUNTRY: LocaleText = {
  pt: "País (ISO-3166 alpha-3).",
  es: "País (ISO-3166 alpha-3).",
  en: "Country (ISO-3166 alpha-3).",
};
export const DOC_LOC_LAT: LocaleText = {
  pt: "Latitude em graus decimais.",
  es: "Latitud en grados decimales.",
  en: "Latitude in decimal degrees.",
};
export const DOC_LOC_LON: LocaleText = {
  pt: "Longitude em graus decimais.",
  es: "Longitud en grados decimales.",
  en: "Longitude in decimal degrees.",
};
export const DOC_LOC_PARKING_TYPE: LocaleText = {
  pt: "Tipo de estacionamento da localização.",
  es: "Tipo de estacionamiento de la ubicación.",
  en: "Parking type of the location.",
};
export const DOC_LOC_OPERATOR: LocaleText = {
  pt: "Detalhes do operador (BusinessDetails).",
  es: "Detalles del operador (BusinessDetails).",
  en: "Operator business details.",
};
export const DOC_LOC_SUBOPERATOR: LocaleText = {
  pt: "Detalhes do suboperador.",
  es: "Detalles del suboperador.",
  en: "Suboperator business details.",
};
export const DOC_LOC_OWNER: LocaleText = {
  pt: "Detalhes do proprietário.",
  es: "Detalles del propietario.",
  en: "Owner business details.",
};
export const DOC_LOC_TIMEZONE: LocaleText = {
  pt: "Fuso horário IANA, ex.: America/Sao_Paulo.",
  es: "Zona horaria IANA, ej.: America/Sao_Paulo.",
  en: "IANA time zone, e.g. America/Sao_Paulo.",
};
export const DOC_LOC_LAST_UPDATED: LocaleText = {
  pt: "Última atualização da localização.",
  es: "Última actualización de la ubicación.",
  en: "Last update of the location.",
};
export const DOC_LOC_EVSES: LocaleText = {
  pt: "Pontos de carga (EVSEs) da localização.",
  es: "Puntos de carga (EVSEs) de la ubicación.",
  en: "Charge points (EVSEs) of the location.",
};
export const DOC_EVSE_UID: LocaleText = {
  pt: "Identificador interno do EVSE.",
  es: "Identificador interno del EVSE.",
  en: "Internal EVSE identifier.",
};
export const DOC_EVSE_ID: LocaleText = {
  pt: "ID público do EVSE (eMI3).",
  es: "ID público del EVSE (eMI3).",
  en: "Public EVSE ID (eMI3).",
};
export const DOC_EVSE_STATUS: LocaleText = {
  pt: "Status operacional do EVSE.",
  es: "Estado operativo del EVSE.",
  en: "Operational EVSE status.",
};
export const DOC_EVSE_CAPABILITIES: LocaleText = {
  pt: "Capacidades do EVSE. START_SESSION_CONNECTOR_REQUIRED é omitido em OCPI 2.2.",
  es: "Capacidades del EVSE. START_SESSION_CONNECTOR_REQUIRED se omite en OCPI 2.2.",
  en: "EVSE capabilities. START_SESSION_CONNECTOR_REQUIRED is omitted under OCPI 2.2.",
};
export const DOC_EVSE_PARKING_RESTR: LocaleText = {
  pt: "Restrições de estacionamento (vazio se nenhuma).",
  es: "Restricciones de estacionamiento (vacío si ninguna).",
  en: "Parking restrictions (empty if none).",
};
export const DOC_EVSE_LAST_UPDATED: LocaleText = {
  pt: "Última atualização do EVSE.",
  es: "Última actualización del EVSE.",
  en: "Last update of the EVSE.",
};
export const DOC_EVSE_CONNECTORS: LocaleText = {
  pt: "Conectores do EVSE.",
  es: "Conectores del EVSE.",
  en: "Connectors of the EVSE.",
};
export const DOC_CONN_ID: LocaleText = {
  pt: "Identificador do conector dentro do EVSE.",
  es: "Identificador del conector dentro del EVSE.",
  en: "Connector identifier within the EVSE.",
};
export const DOC_CONN_STANDARD: LocaleText = {
  pt: "Padrão do conector. Tipos 2.2.1 viram TESLA_S em OCPI 2.2.",
  es: "Estándar del conector. Tipos 2.2.1 caen a TESLA_S en OCPI 2.2.",
  en: "Connector standard. 2.2.1-only types fall back to TESLA_S under OCPI 2.2.",
};
export const DOC_CONN_FORMAT: LocaleText = {
  pt: "Formato do conector: cabo fixo ou tomada.",
  es: "Formato del conector: cable fijo o toma.",
  en: "Connector format: fixed cable or socket.",
};
export const DOC_CONN_POWER_TYPE: LocaleText = {
  pt: "Tipo de potência. Tipos 2.2.1 viram AC_1_PHASE em OCPI 2.2.",
  es: "Tipo de potencia. Tipos 2.2.1 caen a AC_1_PHASE en OCPI 2.2.",
  en: "Power type. 2.2.1-only types fall back to AC_1_PHASE under OCPI 2.2.",
};
export const DOC_CONN_MAX_VOLTAGE: LocaleText = {
  pt: "Tensão máxima (V).",
  es: "Tensión máxima (V).",
  en: "Maximum voltage (V).",
};
export const DOC_CONN_MAX_AMPERAGE: LocaleText = {
  pt: "Corrente máxima (A).",
  es: "Corriente máxima (A).",
  en: "Maximum amperage (A).",
};
export const DOC_CONN_MAX_POWER: LocaleText = {
  pt: "Potência elétrica máxima (W).",
  es: "Potencia eléctrica máxima (W).",
  en: "Maximum electric power (W).",
};
export const DOC_CONN_TARIFF_IDS: LocaleText = {
  pt: "IDs de tarifa aplicáveis ao conector.",
  es: "IDs de tarifa aplicables al conector.",
  en: "Tariff IDs applicable to the connector.",
};
export const DOC_CONN_LAST_UPDATED: LocaleText = {
  pt: "Última atualização do conector.",
  es: "Última actualización del conector.",
  en: "Last update of the connector.",
};

// ─── API doc content: Sessions response fields ──────────────────────────────────

export const DOC_SES_DATA: LocaleText = {
  pt: "Array de objetos Session OCPI.",
  es: "Array de objetos Session OCPI.",
  en: "Array of OCPI Session objects.",
};
export const DOC_SES_ID: LocaleText = {
  pt: "Identificador único da sessão.",
  es: "Identificador único de la sesión.",
  en: "Unique session identifier.",
};
export const DOC_SES_COUNTRY_CODE: LocaleText = {
  pt: "Código do país (ISO-3166 alpha-2).",
  es: "Código del país (ISO-3166 alpha-2).",
  en: "Country code (ISO-3166 alpha-2).",
};
export const DOC_SES_PARTY_ID: LocaleText = {
  pt: "Party ID OCPI do CPO.",
  es: "Party ID OCPI del CPO.",
  en: "OCPI party ID of the CPO.",
};
export const DOC_SES_CURRENCY: LocaleText = {
  pt: "Moeda ISO-4217, ex.: BRL.",
  es: "Moneda ISO-4217, ej.: BRL.",
  en: "ISO-4217 currency, e.g. BRL.",
};
export const DOC_SES_START: LocaleText = {
  pt: "Início da sessão.",
  es: "Inicio de la sesión.",
  en: "Session start time.",
};
export const DOC_SES_END: LocaleText = {
  pt: "Fim da sessão (nulo se ativa).",
  es: "Fin de la sesión (nulo si activa).",
  en: "Session end time (null if active).",
};
export const DOC_SES_KWH: LocaleText = {
  pt: "Energia total entregue (kWh).",
  es: "Energía total entregada (kWh).",
  en: "Total energy delivered (kWh).",
};
export const DOC_SES_STATUS: LocaleText = {
  pt: "Status da sessão.",
  es: "Estado de la sesión.",
  en: "Session status.",
};
export const DOC_SES_AUTH_METHOD: LocaleText = {
  pt: "Método de autorização da sessão.",
  es: "Método de autorización de la sesión.",
  en: "Session authorization method.",
};
export const DOC_SES_AUTH_REF: LocaleText = {
  pt: "Referência de autorização, se houver.",
  es: "Referencia de autorización, si existe.",
  en: "Authorization reference, if any.",
};
export const DOC_SES_COST_EXCL: LocaleText = {
  pt: "Custo total sem impostos.",
  es: "Costo total sin impuestos.",
  en: "Total cost excluding VAT.",
};
export const DOC_SES_COST_INCL: LocaleText = {
  pt: "Custo total com impostos.",
  es: "Costo total con impuestos.",
  en: "Total cost including VAT.",
};
export const DOC_SES_METER_ID: LocaleText = {
  pt: "Identificador do medidor.",
  es: "Identificador del medidor.",
  en: "Meter identifier.",
};
export const DOC_SES_LOCATION_ID: LocaleText = {
  pt: "ID da localização (atualmente igual ao stationID).",
  es: "ID de la ubicación (actualmente igual al stationID).",
  en: "Location ID (currently equal to stationID).",
};
export const DOC_SES_EVSE_UID: LocaleText = {
  pt: "UID do EVSE (atualmente igual ao stationID).",
  es: "UID del EVSE (actualmente igual al stationID).",
  en: "EVSE UID (currently equal to stationID).",
};
export const DOC_SES_CONNECTOR_ID: LocaleText = {
  pt: "Identificador do conector usado.",
  es: "Identificador del conector usado.",
  en: "Identifier of the connector used.",
};
export const DOC_SES_PERIODS: LocaleText = {
  pt: "Períodos de carga com dimensões medidas.",
  es: "Periodos de carga con dimensiones medidas.",
  en: "Charging periods with measured dimensions.",
};
export const DOC_SES_PERIOD_START: LocaleText = {
  pt: "Início do período de carga.",
  es: "Inicio del periodo de carga.",
  en: "Start of the charging period.",
};
export const DOC_SES_DIMENSIONS: LocaleText = {
  pt: "Dimensões medidas no período.",
  es: "Dimensiones medidas en el periodo.",
  en: "Dimensions measured in the period.",
};
export const DOC_SES_DIM_TYPE: LocaleText = {
  pt: "Tipo da dimensão medida.",
  es: "Tipo de la dimensión medida.",
  en: "Type of the measured dimension.",
};
export const DOC_SES_DIM_VOLUME: LocaleText = {
  pt: "Valor da dimensão (unidade depende do tipo).",
  es: "Valor de la dimensión (unidad según el tipo).",
  en: "Dimension value (unit depends on the type).",
};
export const DOC_SES_TARIFF_ID: LocaleText = {
  pt: "Tarifa aplicada ao período.",
  es: "Tarifa aplicada al periodo.",
  en: "Tariff applied to the period.",
};
export const DOC_SES_LAST_UPDATED: LocaleText = {
  pt: "Última atualização da sessão.",
  es: "Última actualización de la sesión.",
  en: "Last update of the session.",
};

// ─── API doc content: Session User Data response fields ─────────────────────────

export const DOC_USR_SESSION_ID: LocaleText = {
  pt: "Identificador da sessão.",
  es: "Identificador de la sesión.",
  en: "Session identifier.",
};
export const DOC_USR_NAME: LocaleText = {
  pt: "Nome completo do usuário.",
  es: "Nombre completo del usuario.",
  en: "User full name.",
};
export const DOC_USR_DOCUMENT: LocaleText = {
  pt: "Documento (CPF/CNPJ/DNI).",
  es: "Documento (CPF/CNPJ/DNI).",
  en: "Government document (CPF/CNPJ/DNI).",
};
export const DOC_USR_EMAIL: LocaleText = {
  pt: "E-mail de contato do titular.",
  es: "Correo de contacto del titular.",
  en: "Account holder contact email.",
};
export const DOC_USR_PHONE: LocaleText = {
  pt: "Telefone de contato do titular.",
  es: "Teléfono de contacto del titular.",
  en: "Account holder contact phone.",
};
export const DOC_USR_STREET: LocaleText = {
  pt: "Logradouro do endereço de cobrança.",
  es: "Calle de la dirección de facturación.",
  en: "Billing address street.",
};
export const DOC_USR_NUMBER: LocaleText = {
  pt: "Número do endereço.",
  es: "Número de la dirección.",
  en: "Address number.",
};
export const DOC_USR_DISTRICT: LocaleText = {
  pt: "Bairro.",
  es: "Barrio.",
  en: "District.",
};
export const DOC_USR_CITY: LocaleText = {
  pt: "Cidade.",
  es: "Ciudad.",
  en: "City.",
};
export const DOC_USR_STATE: LocaleText = {
  pt: "Estado/UF.",
  es: "Estado/provincia.",
  en: "State.",
};
export const DOC_USR_ZIP: LocaleText = {
  pt: "CEP / código postal.",
  es: "Código postal.",
  en: "ZIP / postal code.",
};
export const DOC_USR_CARS: LocaleText = {
  pt: "Veículos associados ao usuário.",
  es: "Vehículos asociados al usuario.",
  en: "Vehicles associated with the user.",
};
export const DOC_USR_CAR_MODEL: LocaleText = {
  pt: "Modelo do veículo.",
  es: "Modelo del vehículo.",
  en: "Vehicle model.",
};
export const DOC_USR_CAR_BRAND: LocaleText = {
  pt: "Marca do veículo.",
  es: "Marca del vehículo.",
  en: "Vehicle brand.",
};
export const DOC_USR_CAR_CAPACITY: LocaleText = {
  pt: "Capacidade da bateria (kWh).",
  es: "Capacidad de la batería (kWh).",
  en: "Battery capacity (kWh).",
};
export const DOC_USR_CAR_AUTONOMY: LocaleText = {
  pt: "Autonomia do veículo (km).",
  es: "Autonomía del vehículo (km).",
  en: "Vehicle range (km).",
};
export const DOC_USR_COUPON: LocaleText = {
  pt: "Cupom de desconto utilizado na sessão. Presente apenas quando um cupom foi aplicado (e não revertido).",
  es: "Cupón de descuento utilizado en la sesión. Presente solo cuando se aplicó un cupón (y no fue revertido).",
  en: "Discount coupon used in the session. Present only when a coupon was applied (and not reverted).",
};
export const DOC_USR_COUPON_NAME: LocaleText = {
  pt: "Nome da campanha do cupom.",
  es: "Nombre de la campaña del cupón.",
  en: "Coupon campaign name.",
};
export const DOC_USR_COUPON_TYPE: LocaleText = {
  pt: "Tipo do benefício: FREE, PERCENTAGE, FIXED_VALUE, CREDIT ou STATION_FIXED_VALUE.",
  es: "Tipo de beneficio: FREE, PERCENTAGE, FIXED_VALUE, CREDIT o STATION_FIXED_VALUE.",
  en: "Benefit type: FREE, PERCENTAGE, FIXED_VALUE, CREDIT or STATION_FIXED_VALUE.",
};
export const DOC_USR_COUPON_CODE: LocaleText = {
  pt: "Código do cupom utilizado.",
  es: "Código del cupón utilizado.",
  en: "Coupon code used.",
};
export const DOC_USR_COUPON_DISCOUNT: LocaleText = {
  pt: "Valor bruto descontado da sessão, em valor monetário decimal.",
  es: "Valor bruto descontado de la sesión, en valor monetario decimal.",
  en: "Gross amount discounted from the session, as a decimal currency value.",
};
